declare const __KITS_DEV_SERVER__: boolean;

export function isDevServer(): boolean {
  return typeof __KITS_DEV_SERVER__ !== 'undefined' && __KITS_DEV_SERVER__;
}
